import _objectSpread from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
export const nullify = () => null;
const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%'
  },
  input: {
    display: 'flex',
    padding: 0,
    backgroundColor: 'white',
    height: 22
  },
  error: {
    border: '1px solid red'
  },
  border: {
    border: '1px solid #ccc'
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center'
  },
  noOptionsMessage: {
    padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px")
  },
  typography: {
    fontSize: 12,
    paddingLeft: 4
  },
  paper: {
    zIndex: 1,
    marginTop: theme.spacing(1),
    backgroundColor: 'white',
    border: '1px solid black',
    width: '500px'
  },
  menuItem: {
    height: 0,
    fontSize: 14
  },
  hide: {
    display: 'none'
  }
});
function NoOptionsMessage(props) {
  return /*#__PURE__*/React.createElement(Typography, Object.assign({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}
function inputComponent(_ref) {
  let inputRef = _ref.inputRef,
    props = _objectWithoutProperties(_ref, ["inputRef"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: inputRef
  }, props));
}
function Control(props) {
  const _props$selectProps = props.selectProps,
    validate = _props$selectProps.validate,
    classes = _props$selectProps.classes,
    name = _props$selectProps.name,
    textFieldProps = _props$selectProps.textFieldProps;
  const border = validate ? classes.error : classes.border;
  return /*#__PURE__*/React.createElement(TextField, Object.assign({
    fullWidth: true,
    InputProps: {
      disableUnderline: true,
      inputComponent,
      inputProps: _objectSpread({
        'data-testid': 'smart-dropdown-input',
        name: name,
        className: "".concat(classes.input, " ").concat(border),
        children: props.children
      }, props.innerProps)
    }
  }, textFieldProps));
}
function Option(props) {
  return /*#__PURE__*/React.createElement(MenuItem, Object.assign({
    classes: {
      root: props.selectProps.classes.menuItem
    },
    buttonRef: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps), props.children);
}
function SingleValue(props) {
  return /*#__PURE__*/React.createElement(Typography, Object.assign({
    className: props.selectProps.classes.typography
  }, props.innerProps), props.children);
}
function ValueContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}
function Menu(props) {
  return (
    /*#__PURE__*/
    // <FormControl fullWidth>
    React.createElement(Popper, Object.assign({
      open: true,
      anchorEl: props.selectProps.inputNode.current,
      className: props.selectProps.classes.paper
    }, props.innerProps, {
      modifiers: {
        preventOverflow: {
          enabled: false,
          boundariesElement: 'scrollParent'
        },
        hide: {
          enabled: false
        }
      }
    }), /*#__PURE__*/React.createElement("div", Object.assign({}, props.innerProps, {
      style: {
        minWidth: props.selectProps.inputNode.current.clientWidth
      },
      "data-testid": "smart-dropdown-menu"
    }), props.children))
    // </FormControl>
  );
}
const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  SingleValue,
  ValueContainer
};
class SmartDropdown extends React.Component {
  constructor() {
    super(...arguments);
    this.inputNode = React.createRef();
    this.state = {
      value: this.props.value,
      label: ''
    };
    this.changeValue = e => {
      this.setState({
        value: e.value || '',
        label: e.label || ''
      }, () => this.props.onChange(e.value));
    };
  }
  componentDidMount() {
    const valueMatch = this.props.options.find(option => option.value === this.props.value);
    if (valueMatch !== undefined) {
      this.setState({
        label: valueMatch.text
      });
    }
  }
  determineIndex(options, choice) {
    let index = -1;
    options.forEach((option, i) => {
      if (option.value === choice) {
        index = i;
      }
    });
    return index;
  }
  render() {
    const _this$props = this.props,
      classes = _this$props.classes,
      theme = _this$props.theme;
    const value = this.state.value;
    const selectStyles = {
      input: base => _objectSpread({}, base, {
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit'
        }
      })
    };
    const newOptions = this.props.options.map(option => ({
      value: option.value,
      label: option.text
    }));
    const hide = this.props.hide ? classes.hide : '';
    const index = this.determineIndex(newOptions, value);
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.root, " ").concat(hide),
      ref: this.inputNode,
      "data-testid": "smart-dropdown",
      id: this.props.id
    }, /*#__PURE__*/React.createElement(NoSsr, null, /*#__PURE__*/React.createElement(Select, {
      classes: classes,
      styles: _objectSpread({}, selectStyles),
      options: newOptions,
      components: components,
      value: newOptions[index],
      onChange: this.changeValue,
      inputNode: this.inputNode,
      openMenuOnFocus: true,
      name: this.props.name,
      onBlur: () => this.props.onBlur(value),
      validate: this.props.validate,
      placeholder: this.props.placeholder
    })));
  }
}
SmartDropdown.defaultProps = {
  id: 'smart-dropdown',
  options: [],
  name: '',
  onChange: nullify,
  onBlur: nullify,
  validate: false,
  hide: false,
  placeholder: '',
  value: ''
};
export default withStyles(styles, {
  withTheme: true
})(SmartDropdown);